import React from 'react';
import {EdapProvider} from '@homeaway/react-event-tracking';
import FilterBar from '../FilterBar/FilterBar';
import FilterForm from '../FilterForm/FilterForm';
import {IntlProvider} from 'react-intl';
import {formatLocale} from '../../utils/localization';

function FiltersContainer(props) {
    const eventcategory = {eventcategory: 'search'};
    const intlLocale = formatLocale(props.locale);

    return (
        <IntlProvider locale={intlLocale} messages={props.messages}>
            <EdapProvider fields={eventcategory}>
                {props.isMobile ? (
                    <FilterForm {...props} />
                ) : (
                    <FilterBar {...props} />
                )}
            </EdapProvider>
        </IntlProvider>
    );
}

export default FiltersContainer;
export {FiltersContainer as Filters};
